'use client';

/**
 * Creates favorites.js widget, only used in recipes for the popover widget,
 * when the component below is updated to another method, remove legacy favorites client
 */

import { runFavorites } from 'components/integrations/FavoritesWidget/favorites';
import { useEffect, useRef } from 'react';

function FavoritesWidgetClient() {
  const init = useRef(false);
  useEffect(() => {
    if (!init.current) {
      runFavorites();
      init.current = true;
    }
  }, []);
  return null;
}

export default FavoritesWidgetClient;
